export default __webpack_public_path__ + "static/media/m-600.0480d2f8.woff2";